/* BlowIt Shop theme: AJAX cart drawer, buy box, sticky bar, videos, small UI bits */
(function () {
  const BI = window.BI || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  function money(cents) {
    const fmt = (BI.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    const v = (cents || 0) / 100;
    const two = v.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return Math.round(v).toLocaleString('en');
      if (k === 'amount_with_comma_separator') return two.replace(/,/g, '.').replace(/\.(\d\d)$/, ',$1');
      return two;
    });
  }
  function toast(msg) { const t = $('#BxToast'); if (!t) return; t.textContent = msg; t.classList.add('show'); clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('show'), 2400); }
  const deviceSVG = '<svg viewBox="0 0 200 380"><use href="#device"/></svg>';
  const thumb = (url, w = 160) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';

  /* ---------- drawers ---------- */
  function openDrawer(id) {
    closeDrawers();
    const d = document.getElementById(id); if (!d) return;
    d.classList.add('open'); d.setAttribute('aria-hidden', 'false');
    $('#BxScrim')?.classList.add('open'); document.body.style.overflow = 'hidden';
  }
  function closeDrawers() {
    $$('.drawer.open').forEach(d => { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); });
    $('#BxScrim')?.classList.remove('open'); document.body.style.overflow = '';
  }
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openDrawer(o.dataset.open); if (o.dataset.open === 'BxCart') loadCart(); return; }
    if (e.target.closest('.drawer [data-close], #BxScrim')) closeDrawers();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- cart ---------- */
  async function api(url, body) {
    const res = await fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong');
    return data;
  }
  async function loadCart() { try { renderCart(await api(BI.routes.cart)); } catch (e) {} }
  function renderCart(cart) {
    const dot = $('#BxCartDot');
    if (dot) { dot.textContent = cart.item_count || ''; }
    const body = $('#BxCartBody'), foot = $('#BxCartFoot'); if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = `<div class="empty"><h4>Your cart is empty</h4><a href="${BI.shopUrl || '/'}#buy" class="btn" data-close>Shop now</a></div>`;
      if (foot) foot.hidden = true; return;
    }
    const note = BI.shipMsg ? `<div class="ship-note">${BI.shipMsg}</div>` : '';
    body.innerHTML = note + cart.items.map((it, i) => `
      <div class="line">
        <div class="line__img">${it.image ? `<img src="${thumb(it.image)}" alt="" style="width:68px;height:68px;object-fit:cover;border-radius:10px">` : deviceSVG}</div>
        <div><h4>${it.product_title}</h4>${it.variant_title ? `<small>${it.variant_title}</small>` : ''}
          <div class="qty"><button data-line="${i + 1}" data-q="${it.quantity - 1}" aria-label="Decrease">−</button><span>${it.quantity}</span><button data-line="${i + 1}" data-q="${it.quantity + 1}" aria-label="Increase">+</button></div></div>
        <div class="line__price">${money(it.final_line_price)}${it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : ''}</div>
      </div>`).join('');
    $('#BxCartTotal').textContent = money(cart.total_price);
    if (foot) foot.hidden = false;
  }
  document.addEventListener('click', async e => {
    const b = e.target.closest('#BxCartBody [data-line]'); if (!b) return;
    b.disabled = true;
    try { renderCart(await api(BI.routes.cartChange, { line: +b.dataset.line, quantity: Math.max(0, +b.dataset.q) })); } catch (err) { toast(err.message); }
  });
  async function addToCart(id, btn) {
    if (!id) { toast('Choose your options first'); return; }
    const old = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    try { await api(BI.routes.cartAdd, { items: [{ id: +id, quantity: 1 }] }); await loadCart(); openDrawer('BxCart'); }
    catch (err) { toast(err.message); }
    if (btn) { btn.disabled = false; btn.innerHTML = old; }
  }
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-bx-add]');
    if (a) { e.preventDefault(); addToCart(a.dataset.bxAdd, a); }
    if (e.target.closest('[data-bx-checkout]')) { e.preventDefault(); location.href = BI.routes.checkout; }
  });

  /* ---------- buy box ---------- */
  function initBuy(root) {
    if (root._bx) return; root._bx = true;
    const sec = root.closest('section') || document;
    const dataEl = $('script[data-bx-product]', sec); if (!dataEl) return;
    const data = JSON.parse(dataEl.textContent);
    const p = data.product; if (!p || !p.variants) return;
    const ui = data.ui || {};
    const lc = s => String(s || '').toLowerCase();
    const kind = name => lc(name) === lc(ui.kit || 'kit') ? 'kit' : lc(name) === lc(ui.pack || 'pack') ? 'pack' : 'seg';
    const start = p.variants.find(v => v.id === data.selected) || p.variants.find(v => v.available) || p.variants[0];
    const state = start.options.slice();
    const single = p.variants.length === 1 && p.options.length === 1;
    const find = sel => p.variants.find(v => v.options.every((o, i) => o === sel[i]));
    const count = val => { const n = parseInt(String(val).replace(/[^0-9]/g, ''), 10); return n > 0 ? n : 1; };
    const packIdx = p.options.findIndex(o => kind(o) === 'pack');

    function render() {
      const kitsEl = $('[data-kits]', root), packsEl = $('[data-packs]', root), segsEl = $('[data-segs]', root);
      if (!single) {
        let kitsHtml = '', packsHtml = '', segHtml = '';
        p.options.forEach((name, i) => {
          const values = [...new Set(p.variants.map(v => v.options[i]))];
          const withVal = val => find(state.map((s, j) => j === i ? val : s));
          const k = kind(name);
          if (k === 'kit') {
            kitsHtml += values.map(val => {
              const v = withVal(val), info = (data.kitInfo || {})[lc(val)] || {};
              const img = v && v.featured_image ? `<img src="${thumb(v.featured_image.src, 80)}" alt="">` : deviceSVG;
              return `<button type="button" class="kitc${val === state[i] ? ' active' : ''}" data-opt="${i}" data-val="${encodeURIComponent(val)}"><span class="kitc__ico">${img}</span><span><b>${val}</b>${info.sub ? `<small>${info.sub}</small>` : ''}</span></button>`;
            }).join('');
          } else if (k === 'pack') {
            packsHtml += values.map(val => {
              const v = withVal(val), info = (data.packInfo || {})[lc(val)] || {};
              const n = count(val), pr = v ? v.price : 0, cmp = v && v.compare_at_price > pr ? v.compare_at_price : 0;
              const save = cmp ? Math.round((1 - pr / cmp) * 100) : 0;
              return `<div class="pack${val === state[i] ? ' active' : ''}${v && !v.available ? ' soldout' : ''}" data-opt="${i}" data-val="${encodeURIComponent(val)}" role="radio" tabindex="0" aria-checked="${val === state[i]}">
                ${info.tag ? `<span class="pack__tag">${info.tag}</span>` : ''}<span class="pack__radio"></span>
                <span class="pack__name"><b>${info.name || val}</b>${save ? `<span class="pack__save">Save ${save}%</span>` : ''}${info.ship ? `<span class="pack__ship">${info.ship}</span>` : ''}${v && !v.available ? '<span class="pack__save" style="color:#c0262d">Sold out</span>' : ''}</span>
                <span class="pack__price"><b>${v ? money(pr) : '—'}</b><small>${n > 1 && v ? money(Math.round(pr / n)) + ' ' + (ui.perUnit || '/ unit') : (cmp ? `<s>${money(cmp)}</s>` : '')}</small></span>
              </div>`;
            }).join('');
          } else {
            segHtml += `<p class="opt-label">${name}</p><div class="seg" style="grid-template-columns:repeat(${Math.min(values.length, 3)},1fr)">${values.map(val => `<button type="button" class="${val === state[i] ? 'active' : ''}" data-opt="${i}" data-val="${encodeURIComponent(val)}">${val}</button>`).join('')}</div>`;
          }
        });
        if (kitsEl) { kitsEl.innerHTML = kitsHtml; kitsEl.hidden = !kitsHtml; }
        if (packsEl) { packsEl.innerHTML = packsHtml; packsEl.hidden = !packsHtml; }
        if (segsEl) segsEl.innerHTML = segHtml;
      }
      update();
    }
    function update() {
      const v = single ? p.variants[0] : find(state);
      const label = !v ? 'Unavailable' : (v.available ? (data.addLabel || 'Add to cart') : 'Sold out');
      $$('[data-bx-buy]').forEach(btn => {
        btn.dataset.bxAdd = v && v.available ? v.id : '';
        btn.disabled = !v || !v.available;
        const l = $('[data-bx-label]', btn); if (l) l.textContent = label;
        const pr = $('[data-bx-price]', btn); if (pr) pr.textContent = v ? money(v.price) : '';
      });
      const sel = $('#BxBarSel'), bp = $('#BxBarPrice');
      if (sel) sel.textContent = single ? p.title : state.join(' · ');
      if (bp) bp.textContent = v ? money(v.price) : '';
      const us = $('[data-bx-unlock-save]', root);
      if (us && v && data.firstPct) { const off = Math.round(v.price * data.firstPct / 100); us.innerHTML = `Save <b>${money(off)}</b> → pay <b>${money(v.price - off)}</b> today`; }
      if (v && v.featured_media) showMedia(sec, v.featured_media.id);
      if (v && data.isProductPage) { const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url); }
    }
    function pick(i, val) {
      state[i] = val;
      if (!find(state)) { const alt = p.variants.find(v => v.options[i] === val && v.available) || p.variants.find(v => v.options[i] === val); if (alt) alt.options.forEach((o, j) => state[j] = o); }
      render();
    }
    root.addEventListener('click', e => { const b = e.target.closest('[data-opt]'); if (b) pick(+b.dataset.opt, decodeURIComponent(b.dataset.val)); });
    root.addEventListener('keydown', e => { const b = e.target.closest('.pack[data-opt]'); if (b && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); pick(+b.dataset.opt, decodeURIComponent(b.dataset.val)); } });
    render();

    /* sticky bar: show once the main button scrolls off screen */
    const main = $('[data-bx-buy]', root), bar = $('#BxBar');
    if (main && bar) {
      new IntersectionObserver(([e]) => { const past = !e.isIntersecting && e.boundingClientRect.top < 0; bar.classList.toggle('show', past); bar.setAttribute('aria-hidden', !past); }).observe(main);
    }
  }
  function showMedia(root, id) {
    const main = $('[data-bx-main]', root); if (!main) return;
    const t = $(`[data-media="${id}"]`, main); if (!t) return;
    $$('[data-media]', main).forEach(m => m.hidden = m !== t);
    $$('[data-thumb]', root).forEach(b => b.classList.toggle('active', b.dataset.thumb === String(id)));
  }

  /* ---------- clicks: gallery thumbs, unlock, reviews, videos, levels ---------- */
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-thumb]');
    if (t) { const sec = t.closest('section'); if (sec) showMedia(sec, t.dataset.thumb); }
    const u = e.target.closest('[data-bx-unlock-open]');
    if (u) { const box = u.closest('.unlock'); box.classList.add('form'); $('input[type=email]', box)?.focus(); }
    const rv = e.target.closest('.rv button');
    if (rv) { const c = rv.closest('.rv'); c.classList.toggle('open'); rv.textContent = c.classList.contains('open') ? 'Show less' : 'Read more'; }
    const vid = e.target.closest('.vid');
    if (vid && !vid.classList.contains('playing')) {
      const tpl = $('template', vid);
      if (tpl) { vid.appendChild(tpl.content.cloneNode(true)); const v = $('video', vid); vid.classList.add('playing'); v && v.play && v.play().catch(() => {}); }
    }
    const lvl = e.target.closest('.level');
    if (lvl) $$('.level', lvl.parentElement).forEach(x => x.classList.toggle('active', x === lvl));
  });

  function init(root = document) { $$('[data-bx-buybox]', root).forEach(initBuy); }
  document.addEventListener('DOMContentLoaded', () => { init(); loadCart(); });
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
